import type { ApplyPageRotationToPlan } from "./types";

export const applyPageRotationToPlan: ApplyPageRotationToPlan = ({
  plan,
  pageIndex,
  rotation,
}) => {
  const updatedRotations = new Map(plan.rotationByPageIndex);
  updatedRotations.set(pageIndex, rotation);
  return { ...plan, rotationByPageIndex: updatedRotations };
};
